module.exports = __webpack_public_path__ + "img/empty.9c79cb52.png";